import { useEffect, useState } from 'react';
import { Box, Divider, ThemeProvider } from '@mui/material';
import Header from './Header';
import Filters from './Filters';
import HeaderBox from '../../../components/shared/boxes/HeaderBox';
import ContainerBox from '../../../components/shared/boxes/ContainerBox';
import InvoicesTable from './InvoicesTable';
import { toSnakeCase } from '../../helpers/helpers';
import ProduttivoMuiThemeV2 from '../../../components/shared/themes/ProduttivoThemeV2';

const InvoicesContainer = ({ accountId }) => {
  const [invoiceQueryParams, setInvoiceQueryParams] = useState({ page: 1, pageSize: 10 });
  const [invoices, setInvoices] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const queryParams = (data) => {
  const params = new URLSearchParams('');

  Object.keys(data).forEach((filterKey) => {
    let key = toSnakeCase(filterKey);

    if (key === "page_size") key = "per_page";

    const filter = data[filterKey];
    if (Array.isArray(filter) && filter.length > 0) {
      filter.forEach((val) => {
        params.append(`${key}[]`, `${val}`);
      });
    } else if (filter) {
      params.append(key, `${filter}`);
    }
  });

  return params.toString();
};

  async function fetchData(params) {
    const response = await fetch('/invoices?' + params, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Oops, não recebemos JSON!');
    }

    const data = await response.json();
    const invoices = data.results.map((invoice) => ({
      ...invoice,
      customerName: invoice.customer?.name || '',
    }));

    if (!response.ok) {
      throw new Error(`Erro da API:', ${data.error}`);
    }
    return { invoices: invoices, count: data.meta.count };
  }

  useEffect(() => {
    async function fetchInvoicesData() {
      const params = queryParams(invoiceQueryParams);
      try {
        const { invoices: result, count } = await fetchData(params);
        setInvoices(result);
        setTotalCount(count);
      } catch (error) {
        console.error(error);
      }
    }

    fetchInvoicesData();
  }, [invoiceQueryParams]);

  const applyPaginationFilter = (data) => {
    const updatedInvoiceQueryParams = { ...invoiceQueryParams, ...data };
    setInvoiceQueryParams(updatedInvoiceQueryParams);
  };

  const applyFilter = (data) => {
    const updatedInvoiceQueryParams = { ...invoiceQueryParams, ...data, page: 1 };
    setInvoiceQueryParams(updatedInvoiceQueryParams);
  };

  return (
    <>
      <Box sx={{ bgcolor: 'background.header' }}>
        <HeaderBox>
          <Header />
          <Divider sx={{ m: '2rem 0' }} />
          <ThemeProvider theme={ProduttivoMuiThemeV2}>
            <Filters applyFilterCallback={applyFilter} accountId={accountId} />
          </ThemeProvider>
        </HeaderBox>
      </Box>
      <Divider />
      <Box sx={{ bgcolor: 'background.default' }}>
        <ContainerBox>
          <InvoicesTable
            invoices={invoices}
            page={invoiceQueryParams.page}
            pageSize={invoiceQueryParams.pageSize}
            totalCount={totalCount}
            applyFilterCallback={applyPaginationFilter}
          />
        </ContainerBox>
      </Box>
    </>
  );
};

export default InvoicesContainer;
